module.exports = __webpack_public_path__ + "static/media/texaco.85be9c89.png";